"use client";

import { useAppDispatch } from "@/store/hooks";
import { setContent, type UnifiedContent } from "@/store/slices/contentSlice";
import { useEffect } from "react";

/**
 * Initializes Redux store with server-side fetched content data
 */
export const ContentInitializer = ({
  getContentData,
}: {
  getContentData: UnifiedContent;
}) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    const fetchAndSetContentData = async () => {
      if (getContentData) {
        dispatch(setContent(getContentData));
      }
    };
    fetchAndSetContentData();
  }, [dispatch, getContentData]);

  // This component doesn't render anything
  return null;
};
